import { createRouteHelpers } from "../../shared/utils/createRouteHelpers";
import { StakeholderFilter } from "./components/TableStakeholders/filters/types";

export const PATH_ACCOUNT_STAKEHOLDERS = "/member/settings/team";

export const PARAMETER_STAKEHOLDER_ID = "stakeholderId";

export const PATH_ACCOUNT_STAKEHOLDERS_ADD = `${PATH_ACCOUNT_STAKEHOLDERS}/add-team-member`;
export const PATH_ACCOUNT_STAKEHOLDERS_EDIT = `${PATH_ACCOUNT_STAKEHOLDERS}/:${PARAMETER_STAKEHOLDER_ID}/edit-team-member`;

export const routeHelpersAccountStakeholders = createRouteHelpers<
  never,
  { search: { filter?: StakeholderFilter } }
>(PATH_ACCOUNT_STAKEHOLDERS);

export const routeHelpersAccountStakeholdersAdd = createRouteHelpers(
  PATH_ACCOUNT_STAKEHOLDERS_ADD
);

export const routeHelpersAccountStakeholdersEdit = createRouteHelpers<{
  stakeholderId: string;
}>(PATH_ACCOUNT_STAKEHOLDERS_EDIT);
